import styled from 'styled-components';
import { CommonDropdown } from 'pg-ui-library';

export const NotificationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const NotificationsInfo = styled.div`
  width: 100%;
  display: flex;
  padding: 8px 12px;
  background-color: #4948ac;
  justify-content: space-between;
  font-size: 16px;
  color: white;
  border-radius: 4px;
  gap: 16px;
  margin-bottom: 16px;
`;

export const CompanyDropdown = styled(CommonDropdown)`
  min-width: 100%;
`;
